import React, { useState } from 'react';
import { Music2, ExternalLink, ChevronDown, ChevronUp } from 'lucide-react';

const SPOTIFY_URL = "https://open.spotify.com/show/6B1NRfylqvaSDTedOPD3iz";
const LOGO_URL = "https://customer-assets.emergentagent.com/job_a027839a-8849-4776-a8ba-c961dd10b69f/artifacts/co2pjy4b_IMG_20260323_062123.jpg";

export default function StickyPlayer() {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div data-testid="sticky-player" className={`fixed bottom-0 left-0 right-0 z-40 sticky-player transition-transform duration-300 ${collapsed ? 'translate-y-[calc(100%-40px)]' : ''}`}>
      {/* Collapse toggle */}
      <button
        data-testid="sticky-player-toggle"
        onClick={() => setCollapsed(!collapsed)}
        className="absolute -top-8 right-4 md:right-8 bg-[#141414] border border-white/10 border-b-0 rounded-t-lg px-3 py-1 flex items-center gap-1.5 text-[#A1A1AA] hover:text-white transition-colors z-10"
      >
        <Music2 size={12} className="text-[#FF2A2A]" />
        <span className="font-body text-[10px] font-bold uppercase tracking-wider">{collapsed ? 'Player' : 'Hide'}</span>
        {collapsed ? <ChevronUp size={12} /> : <ChevronDown size={12} />}
      </button>

      <div className="max-w-7xl mx-auto px-4 md:px-8 py-3 flex items-center gap-4">
        <img src={LOGO_URL} alt="LGITI" className="w-10 h-10 rounded-lg object-cover border border-white/10 hidden sm:block" />
        <div className="flex-1 min-w-0">
          <iframe
            src="https://open.spotify.com/embed/show/6B1NRfylqvaSDTedOPD3iz?utm_source=generator&theme=0"
            width="100%"
            height="80"
            frameBorder="0"
            allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
            loading="lazy"
            title="Let's Get In To It - Spotify Player"
            style={{ borderRadius: '8px' }}
          />
        </div>
        <a
          href={SPOTIFY_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="sticky-player-open-spotify"
          className="hidden sm:flex items-center gap-1.5 bg-[#FF2A2A] text-white font-body text-xs font-bold uppercase tracking-wide px-4 py-2 rounded-lg hover:bg-[#CC0000] transition-colors shrink-0"
        >
          <Music2 size={14} /> Open <ExternalLink size={12} />
        </a>
      </div>
    </div>
  );
}
